`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('other-website.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'other-website' }">{{ $t('other-website.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-table-simple caption-top fixed>
          <caption>{{ $t('other-website.list.traditional-chinese.title') }}</caption>
          <b-tbody>
            <b-tr v-for="website in traditional_chinese_websites">
              <b-td>
                <b-img :src="website.icon" fluid></b-img>
              </b-td>
              <b-td>
                <a :href="website.url">{{ website.label }}</a>
              </b-td>
              <b-td>
                {{ website.description }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-table-simple caption-top fixed>
          <caption>{{ $t('other-website.list.simplified-chinese.title') }}</caption>
          <b-tbody>
            <b-tr v-for="website in simplified_chinese_websites">
              <b-td>
                <b-img :src="website.icon" fluid></b-img>
              </b-td>
              <b-td>
                <a :href="website.url">{{ website.label }}</a>
              </b-td>
              <b-td>
                {{ website.description }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)
Vue.use(TablePlugin)

export default {
  i18n,
  name: "other-website",
  props: {
    // 
  },
  data() {
    return {
      traditional_chinese_websites: [
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/thewisdom.gif',
          label: '大慧集',
          url: 'https://www.thewisdom.com.tw/',
          description: '提供佛教禪宗公案故事動畫、漫畫，並有人物介紹、桌布及小遊戲下載。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/ctworld.gif',
          label: '中台世界',
          url: 'https://www.ctworld.org.tw/',
          description: '介紹禪宗及參禪之道，展示佛學與醫道及禪心世界，並呈現中臺禪寺的弘法理念及概況。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/cbeta.gif',
          label: '中華電子佛典協會',
          url: 'https://www.cbeta.org/',
          description: 'CBETA 數位藏經閣大正藏卍續藏漢文電子佛典目錄, 含協會介紹、全文檢索、光碟下載及索取及相關連結。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/tow.gif',
          label: '中華慧炬',
          url: 'https://www.towisdom.org.tw/',
          description: '中華慧炬佛學會簡介／慧炬之友／獎學金申請表，于凌波教授紀念唯識論文得獎名單，吳品瑜‧部落格、慧炬雜誌社。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/tcbl.jpg',
          label: '台中蓮社',
          url: 'https://www.tclotus.net/',
          description: '雪廬老人李炳南先生所創，儒佛經典。念佛以求當生成就，家庭念佛班及臨終助念團。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/jiexieyin.gif',
          label: '七葉戒邪淫網',
          url: 'http://jxy.book853.com/',
          description: '佛陀及祖師大德關於戒淫的教導和開示。戒淫書籍、文章及戒淫實例。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/fgs.gif',
          label: '佛光山',
          url: 'https://www.fgs.org.tw/',
          description: '介紹佛光山以及佛光山的新聞、活動、人物、服務、教育、文化等。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/sutrapearls.gif',
          label: '佛典妙供',
          url: 'https://www.sutrapearls.org/',
          description: '含佛典格言、佛門對聯、梵音清流 ...'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/buda.gif',
          label: '佛學多媒體',
          url: 'https://www.buda.idv.tw/',
          description: '佛曲音樂，佛學影片，佛像圖庫，演講錄音，討論區，友站連結，提供下載佛學多媒體更多選擇。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/fayun.jpg',
          label: '法雲資訊網',
          url: 'https://fayun.org/public/#!/fy',
          description: '創辦人上玅下境老和尚簡介, 法雲寺禪學院, 出版社, 法雲雜誌, 聯絡資訊, 結緣公告.'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/ddm.gif',
          label: '法鼓山',
          url: 'https://www.ddm.org.tw/',
          description: '包括最新消息、學佛禪修、弘化、護法、行政、文化、教育、法鼓走廊等。'
        },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/buddhist.jpg',
        //   label: '法寶下載網站',
        //   url: 'http://www.buddhist.idv.tw/',
        //   description: '提供法寶寬頻下載，例如：影片（化育故事、德育故事、佛典卡通、電影、開示...）、MP3、圖片等'
        // },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/shiueshin.jpg',
          label: '雪心文教基金會',
          url: 'https://www.shiueshin.org.tw/',
          description: '雪廬老人在世時，有蓮友和一些學生逢年過節供養老人家的紅包。不作私用，全部拿來做弘法利生的事業，雪廬老人親自定名...'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/cbpd.jpg',
          label: '淨律寺',
          url: 'http://www.cbpd.org.tw/',
          description: '淨律學佛院簡介、行事曆。另有副站：淨業學園提供影音下載。'
        },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/sbaweb.gif',
        //   label: '桑耶精舍',
        //   url: 'http://www.sbaweb.org/',
        //   description: '心宏法師的道場，是想效法蓮華生大士的大悲願心，建立包含「三乘教法」的正法城，以利益無量無邊的有情眾生...'
        // },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/bfnn.gif',
          label: '報佛恩網',
          url: 'https://www.bfnn.org/',
          description: '一個總合性的佛教網站, 提供豐富的影音資料。另有副站：般若文海、法音清流、法師大德專輯等。'
        },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/mbi.gif',
        //   label: '慈氏學苑',
        //   url: 'http://mbi.sun.net.tw/',
        //   description: '智中法師致力於佛法的生命教育, 及紓壓安心之道, 以緣起教義及大悲心為體, 結合唯識、四念住、止觀等法門...'
        // },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/maitreya.jpg',
          label: '慈照寺彌勒講堂',
          url: 'https://www.dts.org.tw/',
          description: '彌勒法門 .慈氏學 .彌勒淨土法門 .彌勒菩薩聖像. 住持簡介 .常照法師簡介. 佛法資源 .線上弘法節目...'
        },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/daoyuan.jpg',
        //   label: '道源法師佛堂講話',
        //   url: 'http://daoyuan.idv.st/',
        //   description: '法師生平，海會寺，佛經下載，活動訊息，相關網站。'
        // },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/sanghanet.jpg',
          label: '水月閣',
          url: 'https://www.sanghanet.net/',
          description: '法藏法師理念：以教學天台、行尊律儀、住依僧團、修歸淨土 為總綱；以 痛念生死、發菩提心、三學總持、信願持名 為宗旨...'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/baoyan.jpg',
          label: '寶嚴禪寺',
          url: 'https://www.baoyan.org/',
          description: '寶嚴禪寺以華嚴經、楞嚴經及金剛經為主軸，藉由禪的方式呈現這三部大乘經。提供雲端學習課程、經典下載及共修法會活動，讓學習者透過雲端，循序漸進，深入大乘經論。'
        }
      ],
      simplified_chinese_websites: [
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/cnbuddhism.jpg',
        //   label: '中華佛教',
        //   url: 'http://www.cnbuddhism.com/',
        //   description: '佛教方面, 中華佛教, 中華佛教出版社, 佛教音樂, 佛教新聞等...'
        // },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/tmspxs.gif',
        //   label: '平興寺',
        //   url: 'http://www.tmspxs.com/cz/',
        //   description: '福建平興寺學戒堂推出的線上弘法網站。'
        // },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/jcedu.jpg',
          label: '戒幢佛学教育网',
          url: 'http://www.jcedu.org/',
          description: '西园戒幢律寺，戒幢佛学研究所，所长济群法师主页及图像、法音专区。'
        },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/donglin.jpg',
          label: '东林祖庭',
          url: 'http://www.donglin.org/',
          description: '净土初祖慧远大师创办的道场. 包括净土典籍、往生纪实下载；祖庭动态、大佛工程、净土印经等。'
        },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/0408.gif',
        //   label: '佛教資源',
        //   url: 'http://www.04-08.net/',
        //   description: '佛教資源、信息網上交流等。提供佛教影視、佛教音樂、佛教圖片下載交流等。'
        // },
        {
          icon: 'https://www2.budaedu.org/official-website-data/other-website/seach.gif',
          label: '佛教导航',
          url: 'http://www.fjdh.cn/',
          description: '佛教网址导航，佛教博客，佛教blog，佛教音乐，佛教文库，大藏经下载。佛教图片下载。'
        },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/pureland.gif',
        //   label: '淨土資料',
        //   url: 'http://www.pureland.info/',
        //   description: '佛教淨土宗教義，影音資料下載站，MP3音響目錄，MP4/3GP影像目錄。'
        // },
        // {
        //   icon: 'https://www2.budaedu.org/official-website-data/other-website/lianxin.gif',
        //   label: '蓮心網',
        //   url: 'http://www.lianxin.org.cn/',
        //   description: '蓮心網是中文綜合佛學網站，包括佛教博客、佛教多媒體資料免費下載、善知識在線解惑等內容。'
        // }
      ]
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('other-website.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>